import { render, staticRenderFns } from "./AcaoObjetoImportarModal.vue?vue&type=template&id=49f3cd05&scoped=true"
import script from "./AcaoObjetoImportarModal.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoImportarModal.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoImportarModal.vue?vue&type=style&index=0&id=49f3cd05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f3cd05",
  null
  
)

export default component.exports